/* eslint-disable*/
import React, { useState, useEffect } from "react";
import { InputBox, SubmitButton } from "../../components/Input";
import { API_URL } from "../../config";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import StateManagedSelect from "react-select";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const AddBulkNotification = () => {
  const [formValues, setFormValues] = useState({
    id: "",
    template_name: "",
    email_id: "0",
    sms_id: "0",
    push_id: "0",
    whatsapp_id: "0",
    service_id: "0",
  });

  const [emailTemplates, setEmailTemplates] = useState([]);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [pushTemplates, setPushTemplates] = useState([]);
  const [whatsappTemplates, setWhatsappTemplates] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Start loading immediately
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [templatesLoaded, setTemplatesLoaded] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false); // ✅ new flag for edit data

  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const { id } = useParams();

  // Fetch email templates
  const fetchEmailTemplates = async () => {
    try {
      const response = await axios.get(`${API_URL}settings/template/email/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success && Array.isArray(response.data.data)) {
        const formattedEmailTemplates = response.data.data.map((template) => ({
          value: template.id.toString(),
          label: template.templatename || `Email Template ${template.id}`,
        }));
        setEmailTemplates([
          { value: "0", label: "Select Email Template" },
          ...formattedEmailTemplates,
        ]);
        return formattedEmailTemplates;
      } else {
        setEmailTemplates([{ value: "0", label: "Select Email Template" }]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching email templates", error);
      setEmailTemplates([{ value: "0", label: "Select Email Template" }]);
      return [];
    }
  };

  // Fetch SMS and Push templates
  const fetchSmsAndPushTemplates = async () => {
    try {
      const response = await axios.get(`${API_URL}subscriber/get-template`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      let smsTemplatesData = [];
      let pushTemplatesData = [];

      if (response.data.success && response.data.data) {
        if (
          response.data.data.templateSmsList &&
          Array.isArray(response.data.data.templateSmsList)
        ) {
          smsTemplatesData = response.data.data.templateSmsList.map((template) => ({
            value: template.id.toString(),
            label: template.template_name || `SMS Template ${template.id}`,
          }));
          setSmsTemplates([{ value: "0", label: "Select SMS Template" }, ...smsTemplatesData]);
        } else {
          setSmsTemplates([{ value: "0", label: "Select SMS Template" }]);
        }

        if (
          response.data.data.templatePushNotificationList &&
          Array.isArray(response.data.data.templatePushNotificationList)
        ) {
          pushTemplatesData = response.data.data.templatePushNotificationList.map((template) => ({
            value: template.id.toString(),
            label: template.template_name || `Push Template ${template.id}`,
          }));
          setPushTemplates([{ value: "0", label: "Select Push Template" }, ...pushTemplatesData]);
        } else {
          setPushTemplates([{ value: "0", label: "Select Push Template" }]);
        }
      } else {
        setSmsTemplates([{ value: "0", label: "Select SMS Template" }]);
        setPushTemplates([{ value: "0", label: "Select Push Template" }]);
      }

      return { smsTemplatesData, pushTemplatesData };
    } catch (error) {
      console.error("Error fetching SMS and Push templates", error);
      setSmsTemplates([{ value: "0", label: "Select SMS Template" }]);
      setPushTemplates([{ value: "0", label: "Select Push Template" }]);
      return { smsTemplatesData: [], pushTemplatesData: [] };
    }
  };

  // Fetch WhatsApp templates
  const fetchWhatsappTemplates = async () => {
    try {
      const response = await axios.get(`${API_URL}settings/template/whatsapp/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success && Array.isArray(response.data.data)) {
        const formattedWhatsappTemplates = response.data.data.map((template) => ({
          value: template.id.toString(),
          label: template.templatename || `WhatsApp Template ${template.id}`,
        }));
        setWhatsappTemplates([
          { value: "0", label: "Select WhatsApp Template" },
          ...formattedWhatsappTemplates,
        ]);
        return formattedWhatsappTemplates;
      } else {
        setWhatsappTemplates([{ value: "0", label: "Select WhatsApp Template" }]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching WhatsApp templates:", error);
      setWhatsappTemplates([{ value: "0", label: "Select WhatsApp Template" }]);
      return [];
    }
  };

  // ✅ Fetch Service List
  const fetchServiceList = async () => {
    try {
      const response = await axios.get(`${API_URL}portfolio/serviceList`, {
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success && Array.isArray(response.data.data)) {
        const formattedServices = response.data.data.map((service) => ({
          value: service.id.toString(),
          label: service.service_name || `Service ${service.id}`,
        }));
        setServiceList([{ value: "0", label: "Select Service" }, ...formattedServices]);
      } else {
        setServiceList([{ value: "0", label: "Select Service" }]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServiceList([{ value: "0", label: "Select Service" }]);
    }
  };

  // Fetch all templates
  const fetchTemplates = async () => {
    try {
      await Promise.all([
        fetchEmailTemplates(),
        fetchSmsAndPushTemplates(),
        fetchWhatsappTemplates(),
        fetchServiceList(),
      ]);
      setTemplatesLoaded(true);
    } catch (error) {
      console.error("Error fetching templates:", error);
      setError(error.message);
    }
  };

  // Fetch bulk notification data if editing
  const fetchBulkNotification = async (id) => {
    try {
      const response = await axios.get(`${API_URL}settings/templateBulkCampaign/get/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.template) {
        const notificationData = response.data.template;
        setIsEditing(true);

        setFormValues({
          id: notificationData.id || "",
          template_name: notificationData.template_name || "",
          email_id: notificationData.email_id?.toString() || "0",
          sms_id: notificationData.sms_id?.toString() || "0",
          push_id: notificationData.push_id?.toString() || "0",
          whatsapp_id: notificationData.whatsapp_id?.toString() || "0",
          service_id: notificationData.serviceid?.toString() || "0",
        });
      } else {
        showToast.error("Failed to fetch notification data");
      }
    } catch (error) {
      console.error("Error fetching bulk notification:", error);
      setError(error.message);
      showToast.error("Failed to fetch notification data");
    } finally {
      setDataLoaded(true);
    }
  };

  const findSelectedOption = (options, value) => {
    if (!value || value === "0" || value === 0) return null;
    const stringValue = value.toString();
    return options.find((option) => option.value === stringValue) || null;
  };

  useEffect(() => {
    const loadAllData = async () => {
      setLoading(true);
      await fetchTemplates();

      if (id) {
        await fetchBulkNotification(id);
      } else {
        setDataLoaded(true);
      }

      // ✅ Spinner will hide only when both templates and data are ready
      setLoading(false);
    };

    loadAllData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSelectChange = (name, selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "0";
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: selectedValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValues.template_name.trim()) {
      showToast.error("Template name is required");
      return;
    }

    if (
      formValues.email_id === "0" &&
      formValues.sms_id === "0" &&
      formValues.push_id === "0" &&
      formValues.whatsapp_id === "0"
    ) {
      showToast.error("Please select at least one template");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        template_name: formValues.template_name,
        email_id: Number(formValues.email_id),
        sms_id: Number(formValues.sms_id),
        push_id: Number(formValues.push_id),
        whatsapp_id: Number(formValues.whatsapp_id),
        serviceid: Number(formValues.service_id),
        isdelete: false,
      };

      let response;
      if (isEditing) {
        response = await axios.put(
          `${API_URL}settings/templateBulkCampaign/update/${formValues.id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        response = await axios.post(
          `${API_URL}settings/templateBulkCampaign/save`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }

      if (response.data.success || response.status === 201 || response.status === 200) {
        showToast.success(response.data.message || "Bulk notification saved successfully");
        navigate("/Settings/TemplateBulkCampaign");
      } else {
        showToast.error(response.data.message || "Failed to save bulk notification");
      }
    } catch (error) {
      console.error("Error saving bulk notification:", error);
      if (error.response) {
        showToast.error(error.response.data.message || "Failed to save bulk notification");
      } else {
        showToast.error("Network error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  // ✅ Show spinner until everything (templates + edit data) is loaded
  if (loading || !templatesLoaded || !dataLoaded) {
    return <LoadingSpinner />;
  }

  return (
    <div className="page-header-fixed page-sidebar-fixed fade in mt-5">
      <div>
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0 mb-1">
            <span className="panel-title">
              {isEditing ? "Edit" : "Add"} Bulk Notification Template
            </span>
          </div>
          <hr />
          <form onSubmit={handleSubmit}>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-12">
                  <InputBox
                    label="Template Name"
                    fieldname="template_name"
                    placeholder="Enter Template Name"
                    value={formValues.template_name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <label htmlFor="email_id">Email Template</label>
                  <StateManagedSelect
                    options={emailTemplates}
                    value={findSelectedOption(emailTemplates, formValues.email_id)}
                    onChange={(selected) => handleSelectChange("email_id", selected)}
                    placeholder="Select Email Template"
                    isSearchable
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="whatsapp_id">WhatsApp Template</label>
                  <StateManagedSelect
                    options={whatsappTemplates}
                    value={findSelectedOption(whatsappTemplates, formValues.whatsapp_id)}
                    onChange={(selected) => handleSelectChange("whatsapp_id", selected)}
                    placeholder="Select WhatsApp Template"
                    isSearchable
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <label htmlFor="sms_id">SMS Template</label>
                  <StateManagedSelect
                    options={smsTemplates}
                    value={findSelectedOption(smsTemplates, formValues.sms_id)}
                    onChange={(selected) => handleSelectChange("sms_id", selected)}
                    placeholder="Select SMS Template"
                    isSearchable
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="push_id">Push Notification Template</label>
                  <StateManagedSelect
                    options={pushTemplates}
                    value={findSelectedOption(pushTemplates, formValues.push_id)}
                    onChange={(selected) => handleSelectChange("push_id", selected)}
                    placeholder="Select Push Template"
                    isSearchable
                  />
                </div>
              </div>

              {/* ✅ New Service Dropdown */}
              <div className="row mt-3">
                <div className="col-md-6">
                  <label htmlFor="service_id">Service</label>
                  <StateManagedSelect
                    options={serviceList}
                    value={findSelectedOption(serviceList, formValues.service_id)}
                    onChange={(selected) => handleSelectChange("service_id", selected)}
                    placeholder="Select Service"
                    isSearchable
                  />
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-12">
                  <SubmitButton
                    pageBack="/Settings/TemplateBulkCampaign"
                    handleSubmit={handleSubmit}
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBulkNotification;
